
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FloorDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Floor"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FloorDetailsWithoutStations"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stations"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CameraStationDetails"},"directives":[]}]}}]}}],"loc":{"start":0,"end":203}};
    doc.loc.source = {"body":"#import './CameraStationDetails.graphql'\n#import './FloorDetailsWithoutStations.graphql'\n\nfragment FloorDetails on Floor {\n  ...FloorDetailsWithoutStations\n  stations {\n    ...CameraStationDetails\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require('./CameraStationDetails.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('./FloorDetailsWithoutStations.graphql').definitions));


      module.exports = doc;
    
